import React from 'react';
import { usePermissions } from '../context/PermissionsContext';

const PermissionGuard = ({ 
  module, 
  action, 
  submodule,
  children, 
  fallback = null,
  requireAll = false 
}) => {
  const { hasPermission, canAccessModule } = usePermissions();


  // For simple module access (like Add button)
  if (typeof module === 'object' && module.name && !action) {
    const hasAccess = canAccessModule(module.name);
    return hasAccess ? children : fallback;
  }

  // For specific action permissions with submodule
  if (typeof module === 'object' && module.name && action) {
    let submoduleKey;
    
    if (submodule) {
      // Use provided submodule
      submoduleKey = submodule;
    } else {
      // Use the first submodule for the action check
      const submodules = Object.keys(module.submodules || {});
      if (submodules.length > 0) {
        submoduleKey = module.submodules[submodules[0]];
      }
    }
    
    if (submoduleKey) {
      const hasAccess = hasPermission(module.name, submoduleKey, action);
      return hasAccess ? children : fallback;
    }
  }

  // Handle multiple permissions
  if (Array.isArray(action)) {
    const hasPermissions = action.map(act => hasPermission(module, act));
    const shouldRender = requireAll 
      ? hasPermissions.every(Boolean) 
      : hasPermissions.some(Boolean);
    
    return shouldRender ? children : fallback;
  }

  // Handle single permission (fallback)
  return hasPermission(module, action) ? children : fallback;
};

export default PermissionGuard;